import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar degrade is-fixed-top" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "navbar-burger burger",
    "data-target": "navbarExampleTransparentExample"
  }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkNavBar = _resolveComponent("LinkNavBar")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_LinkNavBar)
  ]))
}